webpackJsonp([49315786557853],{

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(14);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Header = __webpack_require__(16);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(15);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var About = function About(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Header2.default, { data: data }),
	    _react2.default.createElement(
	      "main",
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "wrap" },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "column" },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "column" },
	                _react2.default.createElement(
	                  "h1",
	                  null,
	                  "Talk on the podcast"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "column medium-6" },
	                    _react2.default.createElement(
	                      "form",
	                      { name: "talk-form", method: "post", action: "thanks", "data-netlify": "true", "data-netlify-honeypot": "bot-field" },
	                      _react2.default.createElement("input", { type: "hidden", name: "form-name", value: "talk-form" }),
	                      _react2.default.createElement(
	                        "p",
	                        { hidden: true },
	                        _react2.default.createElement(
	                          "label",
	                          null,
	                          "Don\u2019t fill this out: ",
	                          _react2.default.createElement("input", { name: "bot-field" })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "p",
	                        null,
	                        _react2.default.createElement(
	                          "label",
	                          null,
	                          "Your full name",
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement("input", { type: "text", name: "name" })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "p",
	                        null,
	                        _react2.default.createElement(
	                          "label",
	                          null,
	                          "Your email address",
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement("input", { type: "email", name: "email" })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "p",
	                        null,
	                        _react2.default.createElement(
	                          "label",
	                          null,
	                          "What would you like to discuss on the podcast?",
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement("textarea", { name: "message" })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "p",
	                        null,
	                        _react2.default.createElement(
	                          "button",
	                          { type: "submit", className: "btn" },
	                          "Send"
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, { data: data })
	  );
	};
	
	exports.default = About;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-talk-js-3add4067b2309e4323c9.js